import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import VueStateManager from './infrastructure/state/vue-state-manager';
import { AddressDummyRepository, AddressHttpRepository } from './infrastructure/repository';

// Application
import { SearchAddressQuery } from './application/queries';

// Domain
import { AddressRepository } from './domain/repository';
import { StateManager } from './domain/state/state-manager';

export default function setupState(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';
  container
    .bind<StateManager>(TYPES.CATALOG_KUSPIT_ADDRESS_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<AddressRepository>(TYPES.CATALOG_KUSPIT_ADDRESS_REPOSITORY)
    .to(
      withDummies
        ? AddressDummyRepository
        : AddressHttpRepository,
    )
    .inSingletonScope();

  container
    .bind<SearchAddressQuery>(TYPES.SEARCH_CATALOG_KUSPIT_ADDRESS_QUERY)
    .to(SearchAddressQuery)
    .inSingletonScope();
}
